export default __webpack_public_path__ + "static/media/loyalty-card.13f09b29.png";